import React from "react";
import {useDispatch} from "react-redux";
import {changePageSizeState} from "../../Slices/PageSlice";
import PageSizeState from "../../Constants/Base/PageSizeState";
import {Link} from "react-router-dom";
import {Button} from "@mui/material";
import strings from "../../localization";

const BadRequest = () => {

    const dispatch = useDispatch();
    dispatch(changePageSizeState(PageSizeState.FULL_NO_HEADER));

    return (
        <div className={'error-page'}>
            <h1>400</h1>
            <h3>{ strings.pages.errors.badRequest }</h3>

            <Link to={'/'}>
                <Button variant="contained" color="secondary">
                    { strings.pages.errors.dashboard }
                </Button>
            </Link>
        </div>
    );
};
export default BadRequest;

